import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { 
  Snowflake, 
  ArrowLeft, 
  FileText,
  Mail,
  Phone,
  MapPin
} from "lucide-react";

const Impressum = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-sky-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-lg border-b border-slate-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 text-slate-600 hover:text-sky-500 transition-colors">
            <ArrowLeft className="w-5 h-5" />
            <span>Zurück zur Startseite</span>
          </Link>
          <div className="flex items-center gap-3">
            <Snowflake className="w-6 h-6 text-sky-500" />
            <span className="font-semibold text-slate-900" style={{ fontFamily: 'Playfair Display' }}>
              Grömitzer Eiszeit
            </span>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        {/* Title */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-sky-100 mb-6">
            <FileText className="w-8 h-8 text-sky-600" />
          </div>
          <h1 
            className="text-4xl md:text-5xl font-medium tracking-tight text-slate-900 mb-4"
            style={{ fontFamily: 'Playfair Display' }}
          >
            Impressum
          </h1>
        </div>

        <Card className="border-0 shadow-xl">
          <CardContent className="p-8 md:p-12">
            
            {/* Angaben gemäß § 5 DDG */}
            <section className="mb-10">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Angaben gemäß § 5 DDG
              </h2>
              <div className="bg-slate-50 rounded-xl p-6">
                <p className="font-semibold text-slate-900 text-lg mb-4">Grömitzer Eiszeit</p>
                <p className="font-semibold text-slate-900 mb-1">MK MOMENTS</p>
                <p className="text-slate-600 mb-4">Majid Kalantary</p>
                <div className="space-y-2">
                  <div className="flex items-start gap-3 text-slate-600">
                    <MapPin className="w-5 h-5 mt-0.5 text-sky-500 flex-shrink-0" />
                    <div>
                      <p>Niedernstr. 11</p>
                      <p>23628 Krummesse</p>
                      <p>Deutschland</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 text-slate-600">
                    <Phone className="w-5 h-5 text-sky-500" />
                    <a href="tel:+4901556164249" className="hover:text-sky-600">0155 61642249</a>
                  </div>
                  <div className="flex items-center gap-3 text-slate-600">
                    <Mail className="w-5 h-5 text-sky-500" />
                    <a href="mailto:info@groemitzereiszeit.de" className="hover:text-sky-600">info@groemitzereiszeit.de</a>
                  </div>
                </div>
                <div className="mt-6 pt-6 border-t border-slate-200">
                  <p className="font-semibold text-slate-900 mb-2">In Kooperation:</p>
                  <p className="text-slate-900">Georgs Event GmbH</p>
                  <p className="text-slate-600">Marie-Curie-Str. 1–3</p>
                  <p className="text-slate-600">23701 Eutin</p>
                </div>
              </div>
            </section>

            {/* Verantwortlich für den Inhalt */}
            <section className="mb-10">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
              </h2>
              <div className="bg-slate-50 rounded-xl p-6">
                <p className="font-semibold text-slate-900 mb-1">MK MOMENTS</p>
                <p className="text-slate-900 mb-2">Majid Kalantary</p>
                <p className="text-slate-600">Niedernstr. 11</p>
                <p className="text-slate-600">23628 Krummesse</p>
              </div>
            </section>

            {/* In Kooperation */}
            <section className="mb-10">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Playfair Display' }}>
                In Kooperation
              </h2>
              <div className="bg-slate-50 rounded-xl p-6">
                <p className="font-semibold text-slate-900 mb-1">Georgs Event GmbH</p>
                <p className="text-slate-600">Marie-Curie-Str. 1–3</p>
                <p className="text-slate-600">23701 Eutin</p>
              </div>
            </section>

            {/* Haftung für Inhalte */}
            <section className="mb-10">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Haftung für Inhalte
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>
            </section>

            {/* Haftung für Links */}
            <section className="mb-10">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Haftung für Links
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </section>

            {/* Urheberrecht */}
            <section className="mb-6">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Urheberrecht
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              </p>
            </section>

            {/* Stand */}
            <div className="border-t border-slate-200 pt-6 mt-10">
              <p className="text-slate-500 text-sm text-center">
                (Stand: 2026)
              </p>
            </div>

          </CardContent>
        </Card>

        {/* Back Button */}
        <div className="text-center mt-8">
          <Link to="/">
            <Button className="h-12 px-8 rounded-full bg-sky-500 hover:bg-sky-600 text-white font-semibold">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8 px-6 mt-16">
        <div className="max-w-7xl mx-auto text-center text-slate-500 text-sm">
          <p>© 2026 Grömitzer Eiszeit. Alle Rechte vorbehalten.</p>
        </div>
      </footer>
    </div>
  );
};

export default Impressum;
